const OverviewTypes = Object.freeze({
  Search: 1,
  Marketplace: 3,
  Markets: 4,

  // TODO: remove value below after redesign is applied
  City: 2,
  Category: 5,
})

export default OverviewTypes
